export const APP_API_BASE = process.env.APP_API_BASE || 'https://journal4x-backend-production.up.railway.app';
